'use strict';

// libraries
import 'gsap/TweenMax';
import './ThrowPropsPlugin';
import './CustomEase';


import 'dispatcher';

// utilities
import './utilities/outliner.view';


// components
import './scroll/scrl.component'
import './slider/slider.component';
import './slider/slider-button.component';
import './slider/slider-control.component';
import './form/form.component';
import './form/field-focus.component';
import './form/textarea-autosize.component';
import './form/file.component';
import './form/select.component';
import './decor/main-slider.component';
import './decor/category-slider.component';
import './decor/main-geography.component';
import './decor/marquee-view.component';
import './catalog/assortment-view.component';
import './catalog/catalog-view.component';
import './catalog/assortment-form.component';
import './service/service-form.component';


// modules
import loader          from './navigation/loader-css.view';
import router          from './navigation/router.view';
import template        from './navigation/template.view';

import menu            from './menu/menu.view';
import navHover        from './menu/nav-hover.view';
import popupClose      from './popup/popup-close.view';
import popupControls   from './popup/popup-controls.view';
import popup           from './popup/popup.view';
import response        from './utilities/response.view';
import scrollTop       from './scroll/scroll-top.view';
import scrollTo        from './scroll/scroll-to.view';
import parallax        from './parallax/parallax.view';



require('domready')(function () {
  loader.init();
  router.init();
  template.init();

  menu.init();
  navHover.init();
  popupClose.init();
  popupControls.init();
  popup.init();
  response.init();
  scrollTop.init();
  scrollTo.init();
  parallax.init();
});